import React, { Component } from "react"
import { connect } from 'react-redux'
import {msg} from '../../components/Notifications/MsgBox';
import validateUtil from '../../helpers/validateUtil'

class MainTabMenu extends Component {

    constructor(props) {
        super(props)
        this.isLockTab = this.isLockTab.bind(this)
    }

    isLockTab() {
        let check=false

        this.props.isLockTabIR || !this.props.isLockTabPO ?check=true:check=false;

        return check
    }

    CheckTable(tabid){
        if(tabid=='mr'){
            window.handleMRAmount()
            window.handleMREval()
        }
        if(!this.isLockTab() && tabid == 'gr'){
            window.onChangeTabIR();
            return;
        }
        
        if(this.isLockTab())
        {
            if(!this.props.isLockTabPO && tabid !== 'po')
            {
                msg.error("กรุณากรอกข้อมูล Purchase / Contract Number");
                return "";
            }
            else if(this.props.isLockTabIR && tabid !== 'ir')
            {
                let listError=[]
                validateUtil.addListError(listError
                    ,"T_IR_DETAIL"
                    ,{"error_message": "กรุณาบันทึกข้อมูล Invoice Receipt"}
                )
                msg.warningSave(listError);
                return "";
            }
        }

         return window.onChangeTab(tabid)
        //return
    }

    render() {

        return (
            <div className="row sp-project-counter-wrap">
                <div className="col-md-3 sp-project-counter-panel">
                    <a href="#" className="sp-project-counter-link collapsed" id="rrsPoDetail" data-toggle="collapse" onClick={()=>this.CheckTable("po")}  data-target={this.isLockTab()?"":"#rrsTab1"} aria-expanded="false" aria-controls="rrsTab1">
                        <div className="sp-project-counter-label-box">
                            <div className="sp-project-counter-label">
                                <div className="sp-project-counter-label2">
                                    <span className="sp-project-counter-label-l">PO Detail  </span>
                                </div>
                                <span className="sp-project-counter-label-small">ระบุเงื่อนไขข้อมูลสำหรับบันทึกการประชุม</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-md-2 sp-project-counter-panel">
                    <a href="#" className="sp-project-counter-link " id="rrsMOM" onClick={()=>this.CheckTable("mo")} data-toggle="collapse" data-target={this.isLockTab()?"":"#rrsTab2"} aria-expanded="true" aria-controls="rrsTab2">
                        <div className="sp-project-counter-label-box">
                            <div className="sp-project-counter-label">
                            <div className="sp-project-counter-label2">
                                    <span className="sp-project-counter-label-l">ผลการตรวจรับ  </span>
                                </div>
                                <span className="sp-project-counter-label-small">กรุณาระบุข้อมูลผลการตรวจรับ</span>
                                <span className="sp-project-counter-label-small">ที่มีมติตรวจรับเรียบร้อยแล้วเท่านั้น</span>
                            </div>
                        </div>
                    </a>
                </div>             
                <div className="col-md-2 sp-project-counter-panel">
                    <a href="#" className="sp-project-counter-link collapsed" id="rrsGoodsReceive" onClick={()=>this.CheckTable("gr")} data-toggle="collapse" data-target={this.isLockTab()?"":"#rrsTab3"} aria-expanded="false" aria-controls="rrsTab3">
                        <div className="sp-project-counter-label-box">
                            <div className="sp-project-counter-label">
                                <div className="sp-project-counter-label2">
                                    <span className="sp-project-counter-label-l">Goods Receipt</span>
                                </div>
                                <span className="sp-project-counter-label-small">กรุณาระบุรายละเอียด</span>
                                <span className="sp-project-counter-label-small">Goods Receipt</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-md-2 sp-project-counter-panel">
                    <a href="#" className="sp-project-counter-link collapsed" id="rrsInvoiceReceive" onClick={()=>this.CheckTable("ir")}  data-toggle="collapse" data-target={this.isLockTab()?"":"#rrsTab4"} aria-expanded="false" aria-controls="rrsTab4">
                        <div className="sp-project-counter-label-box">
                            <div className="sp-project-counter-label">
                                <div className="sp-project-counter-label2">
        <span className="sp-project-counter-label-l">Invoice Receipt {this.props.isLockTabIR?<span className="dot-icon"></span>:""} </span>
                                </div>
                                <span className="sp-project-counter-label-small">กรุณาระบุข้อมูลใบแจ้งหนี้</span>
                                <span className="sp-project-counter-label-small">ใบกำกับภาษี</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-md-3 sp-project-counter-panel">
                    <a href="#" className="sp-project-counter-link collapsed" id="rrsCheck" onClick={()=>this.CheckTable("mr")} data-toggle="collapse" data-target={this.isLockTab()?"":"#rrsTab5"} aria-expanded="false" aria-controls="rrsTab5">
                        <div className="sp-project-counter-label-box">
                            <div className="sp-project-counter-label">
                                <div className="sp-project-counter-label2">
                                    <span className="sp-project-counter-label-l">ตรวจรับการจัดหา</span>
                                </div>
                                <span className="sp-project-counter-label-small">กรุณาระบุข้อมูลตรวจรับการจัดหา</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    const { AppRedux } = state
    return {
        isLockTabIR: AppRedux.isLockTabIR,
        isLockTabPO: AppRedux.isLockTabPO
    }
}

export default connect(
    mapStateToProps,
    null
)(MainTabMenu)